import { v4 as uuid } from 'uuid'
import { get } from 'lodash'
import Axios, { AxiosRequestConfig } from 'axios'

import axiosRetry, { exponentialDelay } from 'axios-retry'

import config from '@/config'

export const client = Axios.create({
  responseType: 'json',
})

const _request = client.request
client.request = (axiosRequestConfig: AxiosRequestConfig) => {
  const traceToken = uuid()

  return _request.call(client, {
    ...axiosRequestConfig,
    url: `${config.API_ENDPOINT}${axiosRequestConfig.url}`,
    headers: Object.assign(axiosRequestConfig.headers || {}, {
      'x-sm-trace-token': traceToken, // eslinst-disable-line
    }),
  } as AxiosRequestConfig)

}

axiosRetry(client, {
  retries: 10,
  retryDelay: exponentialDelay,
  retryCondition: error => [502, 503, 504].includes(get(error, 'response.status')),
})

export const request = payload => client.request(payload)
